import { useScrollToTop } from "@/hooks/useScrollToTop";

/**
 * ScrollToTop — Serviway
 * Componente sem UI que faz scroll ao topo em cada mudança de rota.
 * Colocar dentro do Router, antes das rotas.
 */
export default function ScrollToTop() {
  useScrollToTop();
  return null;
}
